var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8881 5.86008V4.08008H20.8881V5.86008H11.0581V4.08008H9.05813V5.86008H2.82812V28.9201H28.9981V5.86008H22.8881ZM26.9981 26.9201H4.82812V14.4901H26.9981V26.9201ZM4.82812 12.4901V7.86008H9.05813V9.64008H11.0581V7.86008H20.8881V9.64008H22.8881V7.86008H26.9981V12.4901H4.82812Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3394 15.9199H13.3594V17.9199H15.3394V15.9199Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9605 19.7002H9.98047V21.7002H11.9605V19.7002Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3394 19.7002H13.3594V21.7002H15.3394V19.7002Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56984 19.7002H6.58984V21.7002H8.56984V19.7002Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9605 23.4902H9.98047V25.4902H11.9605V23.4902Z",
    fill: "#231F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3394 23.4902H13.3594V25.4902H15.3394V23.4902Z",
    fill: "#231F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56984 23.4902H6.58984V25.4902H8.56984V23.4902Z",
    fill: "#231F20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1402 15.9199H20.1602V17.9199H22.1402V15.9199Z",
    fill: "#231F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5191 15.9199H23.5391V17.9199H25.5191V15.9199Z",
    fill: "#231F20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7395 15.9199H16.7695V17.9199H18.7395V15.9199Z",
    fill: "#231F20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1402 19.7002H20.1602V21.7002H22.1402V19.7002Z",
    fill: "#231F20"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5191 19.7002H23.5391V21.7002H25.5191V19.7002Z",
    fill: "#231F20"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7395 19.7002H16.7695V21.7002H18.7395V19.7002Z",
    fill: "#231F20"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7395 23.4902H16.7695V25.4902H18.7395V23.4902Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.92bc204ba920459fb7a725d28208bdff.svg";
export { ForwardRef as ReactComponent };